// extracted by mini-css-extract-plugin
export default {"statsCard":"statsCard_statsCard__rOVqg"};